import React, { useState } from 'react';
import { Menu, LogOut } from 'lucide-react';
import Sidebar from './Sidebar';
import './faculty-ui.css';

export default function FacultyLayout({ title, facultyName, children, rightContent }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  return (
    <div className="faculty-layout">
      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      <div className="faculty-shell">
        <header className="faculty-topbar">
          <div className="faculty-topbar-left">
            <button className="faculty-menu-btn" onClick={() => setMobileOpen((open) => !open)} aria-label="Toggle menu">
              <Menu size={18} />
            </button>
            <div className="faculty-topbar-title">{title}</div>
          </div>
          <div className="faculty-topbar-right">
            {facultyName ? <span>{facultyName}</span> : null}
            {rightContent || null}
            <button className="faculty-topbar-logout" onClick={handleLogout}>
              <LogOut size={16} />
              Logout
            </button>
          </div>
        </header>
        <main className="faculty-content">{children}</main>
      </div>
    </div>
  );
}
